import {useAdminMobileFormat} from './AdminMobileFormatContext';
export default function AdminFormatPreviewNote() {
 const enabled=useAdminMobileFormat();
 const compare=new URLSearchParams(window.location.search);compare.set("mobile_format",enabled?"classic":"admin");
 if(window.location.hostname!=='loewenstarksalesmachine-admin-format-preview.jan-nesic.workers.dev')return null;
 return <aside className="admin-format-preview-note" aria-label="Designvorschau">
  <strong>Vorschau mit Beispieldaten</strong>
  <p>Speichern und Versand sind hier gesperrt.</p>
  <nav aria-label="Vorschaubereiche">
   <a href="/admin/settings?mobile_format=admin">Admin-Vorlage</a>
   <a href="/m/profile?mobile_format=admin">Mitarbeiter</a>
   <a href="/team/contacts?mobile_format=admin">Teamleiter</a>
   <a href="/m/promo?preview_role=promoter_internal&mobile_format=admin">Interner Promoter</a>
   <a href="/promoter?mobile_format=admin">Externer Promoter</a>
  </nav>
  <a href={`${window.location.pathname}?${compare}`}>{enabled?"Bisherige Formatierung ansehen":"Neue Formatierung ansehen"}</a>
 </aside>;
}
